module.exports = __webpack_public_path__ + "static/media/closeWhite.3ea3f864.svg";